export default __webpack_public_path__ + "moin-app-illus-website-header.080c183e270763d46df0e1e7bdffe5c6.png";